import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PatientInfoForm = ({
  patientName,
  setPatientName,
  notes,
  setNotes,
  analysisDate,
  setAnalysisDate,
  errors
}) => {
  const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.75rem',
    fontWeight: '600',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.45)',
    marginBottom: '8px',
    gap: '6px',
  };

  return (
    <div className="space-y-6">

      {/* NAME + DATE */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label style={labelStyle}>
            <Icon name="User" size={12} color="rgba(255,255,255,0.35)" />
            Patient Name <span style={{ color: '#F87171', marginLeft: '2px' }}>*</span>
          </label>
          <Input
            type="text"
            placeholder="Enter patient's full name"
            value={patientName}
            onChange={(e) => setPatientName(e?.target?.value)}
            error={errors?.patientName}
            className="w-full bg-white/[0.05] text-white placeholder-white/20
                       border-white/10 focus:border-blue-500/50
                       focus:ring-blue-500/20"
          />
        </div>

        <div>
          <label style={labelStyle}>
            <Icon name="Calendar" size={12} color="rgba(255,255,255,0.35)" />
            Analysis Date <span style={{ color: '#F87171', marginLeft: '2px' }}>*</span>
          </label>
          <Input
            type="date"
            value={analysisDate}
            onChange={(e) => setAnalysisDate(e?.target?.value)}
            error={errors?.analysisDate}
            className="w-full bg-white/[0.05] text-white border-white/10
                       focus:border-blue-500/50 focus:ring-blue-500/20"
          />
        </div>
      </div>

      {/* NOTES */}
      <div>
        <label style={labelStyle}>
          <Icon name="FileText" size={12} color="rgba(255,255,255,0.35)" />
          Clinical Notes
          <span style={{ color: 'rgba(255,255,255,0.2)', fontWeight: '400', textTransform: 'none', letterSpacing: 'normal', fontSize: '0.75rem' }}>
            — optional
          </span>
        </label>

        <Input
          type="textarea"
          placeholder="Add clinical observations, procedure details, or any relevant notes..."
          value={notes}
          onChange={(e) => setNotes(e?.target?.value)}
          className="w-full bg-white/[0.05] text-white placeholder-white/20
                     border-white/10 focus:border-blue-500/50
                     focus:ring-blue-500/20"
          rows={3}
        />

        <p
          className="flex items-center gap-1.5 mt-2 text-xs"
          style={{ color: 'rgba(255,255,255,0.2)' }}
        >
          <Icon name="Info" size={11} color="rgba(255,255,255,0.2)" />
          These notes will be included in the PDF analysis report.
        </p>
      </div>
    </div>
  );
};

export default PatientInfoForm;
